import React, { Component, useEffect, use, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../etapas/macroscopia/macroscopia.action';
import * as commonActions from '@common/common.action';
import * as editorActions from '../../editor/editor.action';
import * as liberarParcialActions from '../../modais/liberacao_parcial/store/liberacao.action';
import MacroscopiaPage from '../../etapas/macroscopia/macroscopia.page';
import GeracaoBlocosContainer from '../../etapas/macroscopia/operacoes/blocos/gerar-blocos.container';
import ProtocoloMacroscopiaContainer from '../../etapas/macroscopia/operacoes/protocolo/protocolo.container';
import CestaContainer from '../../etapas/macroscopia/operacoes/cesta/cesta.container';
import InconformidadeContainer from '@common/inconformidade/inconformidade.container';
import EtiquetaMacroscopiaContainer from '../../etapas/macroscopia/operacoes/etiqueta/etiqueta.container';
import ExamesEmAbertoContainer from '../../etapas/macroscopia/operacoes/exames/exames.container';
import VincularContainer from '@common/vincular/vincular.container';
import MacroscopiaAPI from './macroscopia.api';
import WebapiCommon from '@common/util/webapi.common';
import { acessoPermitido } from '../../../../acessos.seguranca';
import { getUsuarioLocalStorage } from '../../../../localStorage.util';
import * as acessos from '../../../../acessos.const.util';
import * as editor from '../../editor/editor.util';
import { verificarPlainTextMudou } from '../../editor/editor.util'
import { atalhosLaudo } from '@common/common.const';
import DocumentosExternosContainer from '@common/documentosExternos/documentos-externos.container';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import { etapasEnum, statusEtapasEnum } from '@common/util/defaultValues';
import { errors } from '../../../error/erros';
import ModalLiberacaoParcial from '../../modais/liberacao_parcial';
import ModalLiberacaoTotal from '../../modais/liberacao_total';
import { editorRunat, editorUrl } from '@constants/defaultValues';
import { useIntl } from 'react-intl';
import ModalEncaminhar from '@common/modalEncaminhar/modalEncaminhar';
import { useHistory } from 'react-router-dom';

function MacroscopiaContainer(props) {
  const [modalNoFooter, setmodalNoFooter] = useState(false);
  const [modalTitulo, setmodalTitulo] = useState('');
  const [modalConteudo, setmodalConteudo] = useState();
  const [justificativaCancelar, setjustificativaCancelar] = useState('');
  const [modalStyle, setmodalStyle] = useState({});
  const [timeoutResize, settimeoutResize] = useState(null); //ver
  const [modalConfirmarMensagem, setmodalConfirmarMensagem] = useState('');
  const [modalConfirmarClick, setmodalConfirmarClick] = useState(() => { });
  const [modalConfirmar, setmodalConfirmar] = useState(false);
  const [modalConfirmarType, setmodalConfirmarType] = useState('ok'); // confirm(default) | o
  const [showModalCancelamento, setshowModalCancelamento] = useState(false);
  const [showModalConfirmarCancelamento, setshowModalConfirmarCancelamento] = useState(false);
  const [modalEncaminhar, setModalEncaminhar] = useState(false)
  const [modalEncaminharType, setModalEncaminharType] = useState('ok');
  const [verificarTexto, setVerificarTexto] = useState(false);
  const [textoEditor, setTextoEditor] = useState('');

  const intl = useIntl();
  const history = useHistory();

  useEffect(() => {
    window.addEventListener('message', ({ data }) => {
      if (data.value) {
        if (data.value.plain) {
          setTextoEditor(data.value.plain);
        }
      }
    });

    return () => {
      window.removeEventListener('message', null, true);
      props.commonActions.mudarStatusLaudoFaturado(false);
    }

  }, []);

  useEffect(() => {
    props.commonActions.alterarVisibilidadeAbas({});
    try {
      editor.Inicializar(props, etapasEnum.MACRO.toLowerCase());
    } catch (error) {
      let message = error.message;
      let title = '';
      let origin = `Etapa: ${etapasEnum.MACRO}`;
      const code = 101;

      errors.map((err) => {
        if (err.code === code) {
          title = err.title;
        }
        return err;
      });
      window.location.replace(
        `/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
      );
    }

    const laudarEtapaRequest = {
      pendente: true,
      notificacaoCancer: false,
      exameId: props.detalhes.exameId,
      medicoSolicitante: props.detalhes.solicitante,
      medicoEtapa: props.editor.medExecutante,
      medicoRevisor: props.editor.medRevisor,
    };

    Promise.all([
      WebapiCommon.getExames(),
      WebapiCommon.getMedicos(),
      WebapiCommon.getConfiguracaoMapaMacroscopico(),
      WebapiCommon.getHistoricoNaoConformidades(props.detalhes.laudo),
      WebapiCommon.getBlocos(props.detalhes.laudo),
    ]).then((response) => {
      props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
      props.actions.adicionarBlocosExistentes(response[4]);
      props.actions.listagemExamensLaudo(response[0]);
      props.actions.listagemMedicos(response[1]);
      let configuracao = response[2];
      if (configuracao) {
        let medicoPadraoMacroscopia = configuracao.configuracoesMapaMacroscopicoItems.find(
          (el) => el.coluna === 'Cd_med_padrao_macro'
        );
        if (medicoPadraoMacroscopia) {
          props.commonActions.medicoPadraoMacroscopia(
            medicoPadraoMacroscopia.valor
          );
        }

        let imprimirControleCassetes = configuracao.configuracoesMapaMacroscopicoItems.find(
          (el) => el.coluna === 'Sn_Imprimir_Controle_Cassetes'
        );

        if (imprimirControleCassetes) {
          props.actions.imprimirControleCassetesAoFinalizarMapa(
            imprimirControleCassetes.valor
          );
        }
      }

      if (
        response[3].length &&
        response[3].filter((n) => n.resolucao === null || n.resolucao === '')
          .length
      ) {
        props.commonActions.showAlerta(
          'alerta',
          intl.formatMessage({ id: "dashboards.examDetail.reportNonCompliance" }),
          2000,
          '450px'
        );
      }
    });

    let etapa = props.detalhes.etapas.find(
      (el) => el.etapa.toLowerCase() === etapasEnum.MACRO.toLowerCase()
    );
    props.actions.macroscopiaFinalizada(
      etapa.status === statusEtapasEnum.REALIZADO
    );
    window.addEventListener('resize', handleResize);

    return () => {
      editor.finalizar(props.commonActions);
      settimeoutResize(null);
      props.actions.visibilidadeModalMapaMacroscopico(false);
    }
  }, []);

  useEffect(() => {
    if (props.atalho) {
      var atalho = atalhosLaudo[props.atalho];
      if (atalho) {
        switch (atalho.indice) {
          case '0':
            fechar();
            break;
          case '1':
          case '¹':
            laudar(true, false);
            break;
          case '2':
          case '²':
            setshowModalCancelamento(true);
            break;
          case '3':
          case '³':
            verificaEditor();
            break;
          case '4':
          case '£':
            if (
              !props.exameFinalizado &&
              !props.macroscopiaFinalizada
            )
              alterarVisibilidadeAbas('visibilidadeAutotexto');
            break;
          case '5':
          case '¢':
            if (
              !props.exameFinalizado &&
              !props.macroscopiaFinalizada
            )
              alterarVisibilidadeAbas('visibilidadeFrascos');
            break;
          case '6':
          case '¬':
            alterarVisibilidadeAbas('visibilidadeLaudosAnteriores');
            break;
          case '7':
            alterarVisibilidadeAbas('visibilidadeHistoricoLaudo');
            break;
          case '8':
            if (
              !props.exameFinalizado &&
              !props.macroscopiaFinalizada
            )
              alterarVisibilidadeAbas('visibilidadeListagemAnexo');
            break;
          case '9':
            alterarVisibilidadeAbas('visibilidadeMultiplosExame');
            break;
          case '10':
            incluirInformesClinicosEditor();
            break;
          default:
            break;
        }
        props.commonActions.preencherAtalho(undefined);
      }
    }
  }, [props.atalho]);

  function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue(value + 1);
  }

  const handleResize = useForceUpdate();

  function setJustificativa(texto) {
    setjustificativaCancelar(texto);
  }

  function fechar() {
    let etapa = props.detalhes.etapas.find(
      (e) => e.etapa === etapasEnum.MACRO
    );

    if (
      etapa.status !== statusEtapasEnum.REALIZADO &&
      props.eventokeyUpFoiDisparadoNoEditor
    ) {
      props.actions.visibilidadeModalMapaMacroscopico(true);
      setmodalTitulo(intl.formatMessage({ id: "dashboards.examDetails.saveEditions" }));
      setmodalConteudo(intl.formatMessage({ id: "dashboards.examDetails.saved" }));
    } else {
      //  history.goBack();
      props.commonActions.preenhcerHistoricoInconformidades(undefined);
      props.commonActions.atualizarLarguraEditor('100%');
      //  props.commonActions.showEditor(false);
      props.commonActions.showFadeCarregando(false);
      props.commonActions.changeFecharTela(true);
      verificarPlainTextMudou();
    }
  }

  function alterarFullscreen() {
    props.commonActions.preencherAtalho('ctrl+alt+f10');
  }

  const encaminharSegundaOpiniao = () => {
    setModalEncaminhar(!modalEncaminhar)
  }

  const fecharModalEncaminhar = () => {
    setModalEncaminhar(!modalEncaminhar);
  };

  function construirBotoes() {
    let botoes = [];
    botoes.push({
      backgroundColor: '#4375A3',
      className: 'mv-basico-imprimir',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.reports.printOut' }),
      onClick: () => editor.Imprimir(props.commonActions),
    });

    botoes.push({
      backgroundColor: '#3f8642',
      label: '2',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.referral.referral' }),
      onClick: () => encaminharSegundaOpiniao(),
    });

    if (
      acessoPermitido(props.usuario, acessos.Cassetes) &&
      props.detalhes.laudoAnterior === '0'
    ) {
      botoes.push({
        backgroundColor: '#f44336',
        className: 'fas fa-pager',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.cassettes' }),
        onClick: () => {
          showModal('1');
        },
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.VincularExame) &&
      acessoPermitido(props.usuario, acessos.Adicionar) &&
      !props.macroscopiaFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#418443',
        className: 'fas fa-link',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.link' }),
        onClick: () => {
          showModal('8');
        },
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.DocExterno) &&
      !props.macroscopiaFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#418443',
        className: 'fas fa-file-invoice',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.docExternal' }),
        onClick: () => {
          showModal('9');
        },
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.NaoConformidades) &&
      !props.macroscopiaFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        className: 'fas fa-exclamation-circle',
        backgroundColor: '#4caf50',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.Unconformities' }),
        onClick: () => {
          showModal('4');
        },
      });
    }

    if (acessoPermitido(props.usuario, acessos.Etiqueta)) {
      botoes.push({
        className: 'mv-basico-codigo_barras',
        backgroundColor: '#2196f3',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.label' }),
        onClick: () => {
          showModal('5');
        },
      });
    }

    if (acessoPermitido(props.usuario, acessos.ExamesEmAberto)
    && (props.detalhes.qtdBlocoExterno<= 0 || props.detalhes.qtdLaminaExterno<= 0))
    {
      botoes.push({
        backgroundColor: '#17a2b8',
        className: 'fas fa-flask',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetails.openExams' }),
        totalizador: props.quantidadeLaudosEmAberto,
        onClick: () => {
          showModal('7');
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Macroscopia) &&
      acessoPermitido(props.usuario, acessos.Concluir) &&
      !props.macroscopiaFinalizada &&
      !props.exameFinalizado &&
      !props.visibilidadeLaudosAnteriores
    ) {
      botoes.push({
        backgroundColor: '#3f8642',
        className: 'fas fa-save',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laud' }),
        atalho: 'CTRL+ALT+L',
        onClick: (e) => {
          verificaEditor();
        },
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Macroscopia) &&
      acessoPermitido(props.usuario, acessos.ConcluirPendente) &&
      !props.macroscopiaFinalizada &&
      !props.exameFinalizado &&
      !props.visibilidadeLaudosAnteriores
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'far fa-save',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laudPendent' }),
        atalho: 'CTRL+ALT+P',
        onClick: () => {
          laudar(true, false);
        },
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Macroscopia) &&
      acessoPermitido(props.usuario, acessos.ConcluirConferencia) &&
      !getUsuarioLocalStorage().medicoId &&
      !props.macroscopiaFinalizada &&
      !props.exameFinalizado &&
      !props.visibilidadeLaudosAnteriores
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'fas fa-file-signature',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laudLecturer' }),
        // atalho: 'CTRL+ALT+P',
        onClick: () => {
          laudar(false, false, true);
        },
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.CancelamentoMacro) &&
      props.macroscopiaFinalizada
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'mv-basico-cancelar',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.Cancellation' }),
        atalho: 'CTRL+ALT+N',
        onClick: () => {
          confirmarCancelamentoEtapas();
        },
      });
    }

    botoes.push({
      backgroundColor: '#bbbbbb',
      label: 'F',
      color: '#ffffff',
      atalho: 'CTRL+ALT+O',
      texto: props.intl.formatMessage({ id: 'general.materialArchiving.close' }),
      onClick: () => {
        fechar();
      },
    });

    return botoes;
  }

  function laudar(pendente, concluir, conferencia = false) {
    let alertaMapa = false;
    if (conferencia) {
      return validarMedico(pendente, concluir, alertaMapa, conferencia);
    }


    if (
      props.blocosExistentes.length > 0 &&
      !pendente &&
      !props.detalhes.mapaFinalizado
    ) {
      pendente = true;
      concluir = false;
      alertaMapa = true;
    }

    if (!pendente && !concluir && !conferencia) {
      if (props.historicoInconformidades.length > 0) {
        var inconf = props.historicoInconformidades.filter((nconf) => {
          return nconf.resolucao === '' && nconf.impeditivo;
        });

        if (inconf && inconf.length > 0) {
          props.commonActions.showAlerta(
            'alerta',
            'Este laudo possui uma não conformidade impeditiva',
            2500,
            '450px'
          );
          return;
        }
      }
    }

    validarMedico(pendente, concluir, alertaMapa, conferencia);
  }

  function validarMedico(pendente, concluir, alertaMapa, conferencia) {
    var alertaMedico = false;
    var etapa = props.detalhes.etapas.find(
      (e) => e.etapa === etapasEnum.MACRO
    );
    var user = getUsuarioLocalStorage();

    if (user.medicoId > 0) {
      if (
        props.detalhes.medMacro === null &&
        (etapa.status === statusEtapasEnum.NAO_REALIZADO ||
          etapa.status === statusEtapasEnum.PENDENTE)
      ) {
        WebapiCommon.editarMedicoResponsavelLaudo(
          props.detalhes.laudo,
          user.medicoId,
          'macro',
          'medico'
        ).then(() => {
          var detalhes = { ...props.detalhes };
          detalhes.medMacro = user.medicoId;
          props.commonActions.atualizarDetalhes(detalhes);
          laudarEtapa(pendente, concluir, alertaMedico, alertaMapa);
        });
      } else if (
        props.detalhes.revisorMacro === null &&
        etapa.status === 'revisao'
      ) {
        WebapiCommon.editarMedicoResponsavelLaudo(
          props.detalhes.laudo,
          user.medicoId,
          'macro',
          'revisor'
        ).then(() => {
          var detalhes = { ...props.detalhes };
          detalhes.revisorMacro = user.medicoId;
          props.commonActions.atualizarDetalhes(detalhes);
          laudarEtapa(pendente, concluir, alertaMedico, alertaMapa);
        });
      } else {
        laudarEtapa(pendente, concluir, alertaMedico, alertaMapa, conferencia);
      }
    } else {
      pendente = true;
      alertaMedico = true;
      laudarEtapa(pendente, concluir, alertaMedico, alertaMapa, conferencia);
    }
  }

  function laudarEtapa(pendente, concluir, alertaMedico = false, alertaMapa = false, laudarConferencia = false) {

    let laudarEtapaRequest = {
      ...props.laudarEtapaRequest,
      pendente: pendente,
      concluirLaudo: concluir,
      medicoSolicitante: props.detalhes.solicitante,
      medicoEtapa: props.editor.medExecutante,
      medicoRevisor: props.editor.medRevisor,
      laudarParaConferencia: laudarConferencia,
    };

    props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);

    let msg =
      alertaMedico || alertaMapa
        ? 'Este laudo foi salvo como pendente pois'
        : intl.formatMessage({ id: "dashboards.examDetail.reportSave" });

    msg += alertaMedico ? ' seu usuário não é médico' : '';
    msg += alertaMapa ? ' o mapa ainda não foi concluído' : '';

    let tipo = alertaMapa || alertaMapa ? 'alerta' : 'sucesso';

    props.editorActions.atualizarAviso(msg, tipo);

    editor.laudar(props.commonActions);
    props.commonActions.showAlerta(
      'sucesso',
      intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
      2000
    );
  }

  function showModal(index) {
    setmodalNoFooter(false);
    let componente = undefined;
    let style = {};
    // let titulo = '';
    new Promise((resolve) => {
      switch (index) {
        case '1':
          setmodalNoFooter(true);
          componente = (
            <GeracaoBlocosContainer
              intl={intl}
              macroscopiaFinalizada={props.macroscopiaFinalizada}
              exameFinalizado={props.exameFinalizado}
              fecharModal={() => {
                setmodalNoFooter(false);
                props.actions.visibilidadeModalMapaMacroscopico(false);
              }}
            />
          );
          resolve(
            resolveShowModal(
              componente,
              intl.formatMessage({ id: "dashboards.examDetails.examCassetteGeneration" })/* `${props.detalhes.laudo}` */
            )
          );
          break;
        case '2':
          resolve(
            resolveShowModal(
              <ProtocoloMacroscopiaContainer />,
              intl.formatMessage({ id: "dashboards.examDetails.reportProtocol" })
            )
          );
          break;
        case '3':
          resolve(
            resolveShowModal(
              <CestaContainer />,
              intl.formatMessage({ id: "dashboards.examDetails.reportBaskets" })
            )
          );
          break;
        case '4':
          style = { maxWidth: '1000px' };
          componente = (
            <InconformidadeContainer
              intl={intl}
              altura={window.innerHeight - 200}
              funcFechar={() => {
                closeModal();
                fechar();
              }}
              etapa={etapasEnum.MACRO}
            />
          );

          resolve(
            resolveShowModal(
              componente,
              intl.formatMessage({ id: "dashboards.examDetails.noncomplianceReport" }),
              style
            )
          );
          break;
        case '5':
          resolve(
            resolveShowModal(
              <EtiquetaMacroscopiaContainer />,
              intl.formatMessage({ id: "dashboards.examDetails.reportLabels" }),
            )
          );
          break;
        case '7':
          resolve(
            resolveShowModal(
              <ExamesEmAbertoContainer />,
              intl.formatMessage({ id: "dashboards.examDetails.openExamReport" })
            )
          );
          break;
        case '8':
          componente = (
            <VincularContainer
              history={history}
              altura={window.innerHeight - 215}
            />
          );
          resolve(
            resolveShowModal(
              componente,
              intl.formatMessage({ id: "dashboards.examDetail.linkPastExams" })
            )
          );
          break;
        case '9':
          props.commonActions.showFadeCarregando(true);
          WebapiCommon.obterListagemDocumentosLaudo(
            props.detalhes.laudo
          ).then((listagem) => {
            componente = (
              <DocumentosExternosContainer altura={window.innerHeight - 215} />
            );

            props.commonActions.atualizarListagemDocumentosExternos(
              listagem
            );
            props.commonActions.showFadeCarregando(false);
            resolve(resolveShowModal(componente, 'Documentos Externos'));
          });
          break;
        case '10':
          setmodalConfirmarMensagem(intl.formatMessage({ id: "dashboards.examDetail.notTyped" }));
          setmodalConfirmarType('ok');
          setmodalConfirmarClick(() => setmodalConfirmar(!modalConfirmar));
          return setmodalConfirmar(true);
        default:
          resolve(resolveShowModal(undefined));
          break;
      }
    });
  }

  function resolveShowModal(componente, titulo, style) {
    setmodalConteudo(componente);
    setmodalTitulo(titulo);
    setmodalStyle(style);
    props.actions.visibilidadeModalMapaMacroscopico(true);
  }

  function closeModal() {
    props.commonActions.eventokeyUpFoiDisparadoNoEditor(false);
    props.actions.visibilidadeModalMapaMacroscopico(false);
    props.commonActions.editorInicializado(false);
    _fechar();
  }

  function _fechar() {
    //props.commonActions.atualizarDetalhes(undefined);
    props.commonActions.alterarVisibilidadeAbas({});
    props.commonActions.preenhcerHistoricoInconformidades(undefined);
    props.actions.collapedContainerExames(true);
    props.commonActions.atualizarLarguraEditor('100%');
    props.commonActions.showEditor(false);
    history.goBack();
  }

  function confirmaModal() {
    props.commonActions.showFadeCarregando(true);
    const frame = document.getElementById('iframe-editor');

    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'TextoLaudoRtf', //'recuperarTextoRtf',
          urlHost: editorUrl,
          args: {
            action: 'autosave',
          },
        },
        editorUrl
      );
    } else {
      props.commonActions.showModalMacroAlteracaoLaudo(false);
      props.actions.visibilidadeModalMapaMacroscopico(false);
    }

    props.commonActions.alterarVisibilidadeAbas({});
    props.commonActions.preenhcerHistoricoInconformidades(undefined);
    props.actions.collapedContainerExames(true);
    props.commonActions.atualizarLarguraEditor('100%');
    props.commonActions.showEditor(false);
    props.commonActions.showFadeCarregando(false);
    history.goBack();
  }

  function confirmarCancelamentoEtapas() {
    setshowModalConfirmarCancelamento(true);
  }

  function toggleModalConfirmarCancelamento() {
    setshowModalConfirmarCancelamento(false);
  }

  function cancelamentoMacrocoscopia() {
    setshowModalCancelamento(true);
  }

  function toggleModalCancelamento() {
    setshowModalCancelamento(false);
  }

  function cancelarMacro() {
    props.commonActions.showFadeCarregando(true);
    MacroscopiaAPI.cancelamentoMacro(
      props.detalhes.laudo,
      justificativaCancelar
    ).then((res) => {
      const listagem = [...props.listagemCommon];
      const listagemIndex = listagem.findIndex(
        item => item.laudo === props.detalhes.laudo
      );
      if (listagemIndex >= 0) {
        listagem[listagemIndex].dataLiberacao = '';
        listagem[listagemIndex].isLaudoLiberado = false;
        listagem[listagemIndex].isLiberadoParcial = false;
        listagem[listagemIndex].isLiberadoTotal = false;
        props.commonActions.preencherListagem(listagem);
      }

      WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
        (etapas) => {
          props.commonActions.atualizarStatusDasEtapasDoLaudo(
            etapas,
            props.detalhes.laudo
          );
          props.commonActions.showEditor(false);
          props.commonActions.showFadeCarregando(false);
          toggleModalCancelamento();
          _fechar();
        }
      );
    });
  }

  function cancelarEtapasPosteriores() {
    props.commonActions.showFadeCarregando(true);
    const listagem = [...props.listagemCommon];
    const listagemIndex = listagem.findIndex(
      item => item.laudo === props.detalhes.laudo
    );
    if (listagemIndex >= 0) {
      listagem[listagemIndex].dataLiberacao = '';
      listagem[listagemIndex].isLaudoLiberado = false;
      listagem[listagemIndex].isLiberadoParcial = false;
      listagem[listagemIndex].isLiberadoTotal = false;
      props.commonActions.preencherListagem(listagem);
    }

    WebapiCommon.cancelarEtapasPosteriores(
      props.detalhes.laudo,
      props.etapaAtual,
      0,
      justificativaCancelar
    )
      .then((resp) => {
        if (resp.success) {
          props.commonActions.showAlerta(
            'sucesso',
            resp.data.mensagem,
            2000
          );

          WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
            (etapas) => {
              props.commonActions.atualizarStatusDasEtapasDoLaudo(
                etapas,
                props.detalhes.laudo
              );
              props.commonActions.showEditor(false);
              props.commonActions.showFadeCarregando(false);
              toggleModalCancelamento();
              toggleModalConfirmarCancelamento();
              _fechar();
            }
          )
        }
        else {
          props.commonActions.showFadeCarregando(false);
          props.commonActions.showAlerta(
            'erro',
            intl.formatMessage({ id: "dashboards.examDetail.unableCancelSteps" }),
            2000
          );
          toggleModalCancelamento();
          toggleModalConfirmarCancelamento();

        }
      })
      .catch((error) => {
        props.commonActions.showFadeCarregando(false);
        props.commonActions.showAlerta(
          'erro',
          intl.formatMessage({ id: "dashboards.examDetail.unableCancelSteps" }),
          2000
        );
        toggleModalCancelamento();
        toggleModalConfirmarCancelamento();
      });
  }

  useEffect(() => {
    if (textoEditor !== undefined && verificarTexto) {
      setVerificarTexto(false);
      props.commonActions.showFadeCarregando(true);
      if (!textoEditor || textoEditor.trim() === '') {
        props.commonActions.showFadeCarregando(false);
        return showModal('10');
      }
      props.commonActions.showFadeCarregando(false);
      return laudar(false, false);
    }
    props.commonActions.showFadeCarregando(false);

  }, [textoEditor, verificarTexto]);

  function verificaEditor() {
    props.commonActions.showFadeCarregando(true);
    const frame = document.getElementById('iframe-editor');

    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'recuperarTextoRtfAndPlainText',
          urlHost: editorUrl,
          args: {
            action: 'getPlainText'
          }
        },
        editorUrl
      );
    }

    setTimeout(() => {
      props.commonActions.showFadeCarregando(false);
      return setVerificarTexto(true);
    }, 200);

  }

  function incluirInformesClinicosEditor() {
    const laudo = props.detalhes.laudo;
    props.commonActions.showFadeCarregando(true);
    WebapiCommon.getInformesClinicos(laudo).then((response) => {
      if (response.data && response.data !== '') {
        const frame = document.getElementById('iframe-editor');
        frame.contentWindow.postMessage(
          {
            method: 'inserirTexto',
            text: btoa(response.data),
            type: 'rtf',
            runat: editorRunat,
            breakLine: false,
            cleanBefore: false,
          },
          editorUrl
        );

        props.commonActions.showAlerta('sucesso', intl.formatMessage({ id: "dashboards.examDetail.reportAddedReport" }), 2000);
      } else {
        props.commonActions.showAlerta('alerta', intl.formatMessage({ id: "dashboards.examDetail.noClinicalReportExam" }), 2000);
      }
    });

    props.commonActions.showFadeCarregando(false);
  }

  function alterarVisibilidadeAbas(propriedadeNoEstado) {
    const visibilidade = !props[propriedadeNoEstado];
    const larguraEditor = visibilidade
      ? 'calc(100% - 33.333333% - 10px)'
      : '100%';
    props.commonActions.alterarVisibilidadeAbas({
      [propriedadeNoEstado]: visibilidade
    });
    props.commonActions.atualizarLarguraEditor(larguraEditor);
  }

  return (
    <React.Fragment>
      <ModalEncaminhar
        toggleModalEncaminhar={() => setModalEncaminhar(!modalEncaminhar)}
        type={modalEncaminharType}
        showModalEncaminhar={modalEncaminhar}
        titulo={'Encaminhar'}
        mensagem={'Encaminhar'}
        confirmar={() => fecharModalEncaminhar()}
        laudo={props.detalhes.laudo}
        commonActions={props.commonActions}
      />
      <ModalConfirmar
        toggleModalConfirmar={() => setmodalConfirmar(!modalConfirmar)}
        type={modalConfirmarType}
        showModalConfirmar={modalConfirmar}
        titulo={intl.formatMessage({ id: "dashboards.examDetail.headsUp" })}
        mensagem={modalConfirmarMensagem}
        confirmar={modalConfirmarClick}
      />
      <ModalLiberacaoParcial />
      <ModalLiberacaoTotal />
      <MacroscopiaPage
        modalNoFooter={modalNoFooter}
        usuario={props.usuario}
        detalhes={props.detalhes}
        altura={window.innerHeight - props.altura - 184}
        modalVisivel={props.visibilidadeModalMapaMacroscopico}
        modalTitulo={modalTitulo}
        modalConteudo={modalConteudo}
        modalStyle={modalStyle}
        showModal={(e) => showModal(e)}
        closeModal={(e) => closeModal(e)}
        fecharModal={() => {
          setmodalNoFooter(false);
          props.actions.visibilidadeModalMapaMacroscopico(false);
        }}
        confirmaModal={(e) => confirmaModal(e)}
        getActionsButtons={construirBotoes()}
        showModalCancelamento={showModalCancelamento}
        toggleModalCancelamento={(e) => toggleModalCancelamento(e)}
        cancelarMacro={(e) => cancelarMacro(e)}
        acessoPermitido={acessoPermitido}
        alterarFullscreen={(e) => alterarFullscreen(e)}
        macroscopiaFinalizada={props.macroscopiaFinalizada}
        exameFinalizado={props.exameFinalizado}
        justificativaCancelar={justificativaCancelar}
        setJustificativa={(e) => setJustificativa(e)}
        incluirInformesClinicosEditor={(e) => incluirInformesClinicosEditor(e)}
        ModalLiberacaoParcial={props.liberarLaudoParcialmente}
        showModalConfirmacaoCancelamento={(e) => cancelamentoMacrocoscopia(e)}
        showModalConfirmarCancelamento={
          showModalConfirmarCancelamento
        }
        toggleModalConfirmarCancelamento={(e) => toggleModalConfirmarCancelamento(e)}
        cancelarEtapas={(e) => cancelarEtapasPosteriores(e)}
        alterarVisibilidadeAbas={(e) => alterarVisibilidadeAbas(e)}
        visibilidadeAutotexto={props.visibilidadeAutotexto}
        visibilidadeFrascos={props.visibilidadeFrascos}
        visibilidadeLaudosAnteriores={props.visibilidadeLaudosAnteriores}
        visibilidadeListagemAnexo={props.visibilidadeListagemAnexo}
        visibilidadeHistoricoLaudo={props.visibilidadeHistoricoLaudo}
        visibilidadeMultiplosExame={props.visibilidadeMultiplosExame}
        visibilidadeListaLaminas={props.visibilidadeListaLaminas}
        quantidadeLaudosAnteriores={props.quantidadeLaudosAnteriores}
      />
    </React.Fragment>
  );
}



const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    editorActions: bindActionCreators(editorActions, dispatch),
    liberarParcialActions: bindActionCreators(liberarParcialActions, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    editor: state.editor,
    mensagem: state.editor.mensagem,
    usuario: state.usuario,
    altura: state.commonReducer.altura,
    detalhes: state.commonReducer.detalhes,
    atalho: state.commonReducer.atalho,
    editorCarregado: state.commonReducer.editorCarregado,
    listagem: state.macroscopia.listagem,
    listagemCommon: state.commonReducer.listagem,
    laudarEtapaRequest: state.commonReducer.laudarEtapaRequest,
    macroscopiaFinalizada: state.macroscopia.macroscopiaFinalizada,
    historicoInconformidades: state.commonReducer.historicoInconformidades,
    exameFinalizado: state.commonReducer.exameFinalizado,
    eventokeyUpFoiDisparadoNoEditor:
      state.commonReducer.eventokeyUpFoiDisparadoNoEditor,
    blocosExistentes: state.macroscopia.blocosExistentes,
    visibilidadeModalMapaMacroscopico:
      state.macroscopia.visibilidadeModalMapaMacroscopico,
    etapaAtual: state.commonReducer.etapa.etapa,
    visibilidadeMultiplosExame: state.commonReducer.visibilidadeMultiplosExame,
    visibilidadeHistoricoLaudo: state.commonReducer.visibilidadeHistoricoLaudo,
    visibilidadeFrascos: state.commonReducer.visibilidadeFrascos,
    visibilidadeListaLaminas: state.commonReducer.visibilidadeListaLaminas,
    visibilidadeAutotexto: state.commonReducer.visibilidadeAutotexto,
    visibilidadeLaudosAnteriores:
      state.commonReducer.visibilidadeLaudosAnteriores,
    visibilidadeListagemAnexo: state.commonReducer.visibilidadeListagemAnexo,
    quantidadeLaudosAnteriores: state.commonReducer.quantidadeLaudosAnteriores,
    quantidadeLaudosEmAberto: state.commonReducer.quantidadeLaudosEmAberto
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MacroscopiaContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/macroscopia.container.js